module.exports = __webpack_public_path__ + "img/05 Animation 2-squashed.1cbf0b13.jpg";